import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Navigate } from "react-router-dom";
import { Card, Grid, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default class UpdateCareer extends Component {
  state = {
    id: "",
    description: "",
    // this will hold the file user selects
    subject_poster: null,
    // this holds existing image path from backend
    existing_poster: "",
    message: "",
    notification: false,
    redirect: false,
    loading: false,
    youtube_id: "",
  };

  componentDidMount() {
    const id = window.location.pathname.split("/")[2];
    this.setState({ id });
    if (id) {
      this.getSingleSubject(id);
    }
  }

  getSingleSubject = async (id) => {
    try {
      if (init() === "success") {
        const resp = await axios.get(Constants.getUrls.getAboutUs + "/" + id);
        // assuming resp.data.data has: { description, subject_poster }
        this.setState({
          description: resp.data.data.description || "",
          existing_poster: resp.data.data.image || "",
          youtube_id: resp.data.data.youtube_id,
        });
      } else {
        this.setState({ redirect: true });
      }
    } catch (error) {
      console.log(error);
      this.setState({
        notification: true,
        message: "Error fetching About Us data",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 3000);
    }
  };

  handleDescription = (content) => {
    this.setState({ description: content });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (init() !== "success") {
      this.setState({ redirect: true });
      return;
    }

    this.setState({ loading: true });

    const formData = new FormData();
    formData.append("description", this.state.description);
    formData.append("youtube_id", this.state.youtube_id);

    // Only append image if a new file is selected
    if (this.state.subject_poster instanceof File) {
      formData.append("image", this.state.subject_poster);
    }

    axios
      .put(Constants.putUrls.updateAboutUs + this.state.id, formData)
      .then((resp) => {
        this.setState({
          notification: true,
          message: resp.data.message,
          loading: false,
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "", redirect: true });
        }, 3000);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          message: err.response?.data?.message || "Error updating About Us",
          loading: false,
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 5000);
      });
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/aboutus" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update About Us
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* Existing image preview */}
                  {this.state.existing_poster && (
                    <Grid item sm={6} xs={12}>
                      <MDTypography variant="button" fontWeight="medium">
                        Current About Us Poster
                      </MDTypography>
                      <MDBox mt={1}>
                        <img
                          src={Constants.imageDomain + this.state.existing_poster}
                          alt="About Us Poster"
                          style={{ maxWidth: "100%", maxHeight: 200, objectFit: "cover" }}
                        />
                      </MDBox>
                    </Grid>
                  )}

                  <Grid item sm={6}>
                    <TextField
                      type="text"
                      label="Youtube Id"
                      name="youtube_id"
                      focused
                      onChange={(e) => {
                        this.setState({
                          youtube_id: e.target.value,
                        });
                      }}
                      value={this.state.youtube_id}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Grid>

                  {/* Upload new image */}
                  <Grid item sm={6} xs={12}>
                    <TextField
                      type="file"
                      name="subject_poster"
                      label="Upload New About Us Poster"
                      fullWidth
                      focused
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        this.setState({
                          subject_poster: e.target.files[0] || null,
                        });
                      }}
                    />
                  </Grid>

                  {/* Description editor */}
                  <Grid item sm={12} xs={12}>
                    <MDTypography variant="button" fontWeight="medium" mb={1}>
                      About Us Description
                    </MDTypography>
                    <SunEditor
                      setDefaultStyle="font-family: Arial; font-size: 16px;"
                      setOptions={{
                        buttonList: [
                          ["undo", "redo"],
                          ["font", "fontSize"],
                          ["paragraphStyle", "blockquote"],
                          ["bold", "underline", "italic", "strike", "subscript", "superscript"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list", "lineHeight"],
                          ["outdent", "indent"],
                          ["table", "horizontalRule", "link", "image", "video"],
                          ["imageGallery"],
                          ["preview", "print"],
                          ["removeFormat"],
                        ],
                        defaultTag: "div",
                        height: 200,
                        showPathLabel: false,
                      }}
                      name="description"
                      setContents={this.state.description}
                      onChange={this.handleDescription}
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Updating..." : "Update"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              icon="notifications"
              title="VASA | About US"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
